export default {
  "custom-no-header": () => import("/vercel/path0/layouts/custom-no-header.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)
}